(function ($, Drupal) {
  'use strict';

  //Click off function
  $.fn.clickOff = function(callback, selfDestroy) {
    var clicked = false;
    var parent = this;
    var destroy = selfDestroy || true;

    parent.click(function() {
      clicked = true;
    });

    $(document).click(function(event) {
      if (!clicked) {
        callback(parent, event);
      }
      if (destroy) {
        //parent.clickOff = function() {};
        //parent.off("click");
        //$(document).off("click");
        //parent.off("clickOff");
      }
      clicked = false;
    });
  };

  // Subnav open
  function subNavOpen(li) {

    $(li).on('click', function (e) {

      if(window.innerWidth < 1000) {

        $("#primary-nav .menu-item").off('click', closeNav);
        e.stopPropagation();
        if($(e.target).hasClass('menu-item')) {
          $(e.target).siblings().find('.menu').removeClass('active');
          $(e.target).find('> .menu').toggleClass('active');
        } else {
          $(e.target).parent().siblings().find('.menu').removeClass('active');
          $(e.target).parent().find('> .menu').toggleClass('active');
        }
        return;
      }

      if(window.innerWidth > 1000) {

        $("#primary-nav .menu-item").on('click', closeNav);
        e.stopPropagation();
        $(this).parent().siblings().find('.menu').removeClass('active');
        $(this).parent().find('> .menu').toggleClass('active');


      }
    });

  }

  // Clear all active state of the nav
  function clearNav() {
    $('#primary-nav, #primary-nav ul.menu, #primary-nav li').removeClass('active');
  }

  // What to do on the nav closed
  function closeNav() {
    $('#header .hamburger').removeClass('is-active');
    clearNav();
    $('.fade').removeClass('show');
  }

  //Search
  var $search = $('.form-type-search');
  function closeSearch() {
    $search.removeClass('opened').find('input.seach').value('');
  }

  $('svg', $search).on('click', function () {
    $(this).parents($search).toggleClass('opened');
  });

  /**
   * Search functionality for main search.
   */

  $('#keyword').on('change', function (event) {
    event.preventDefault();
    $('#site-search').submit();
  });

  $('#site-search').on('submit', function(event) {
    var keyword = $('#keyword').val() || $('.search-404 .search').val();

    $('#site-search')
      .attr('action', '/search/site/')
      .attr('action', function(i, value) {
        return value + keyword;
      })
  });

  /**
   * Search functionality for 404 page search form.
   * The 404 form page form passes the data to the main
   * search form, who performs the search.
   */

  $('form.search-404').on('change submit', function (event) {
    event.preventDefault();

    $('form#site-search').submit();

  });

  // Desktop nav
  var $fade = $('.fade');
  $('#primary-nav >.menu > li > span').on('click', function (ev) {
    ev.stopPropagation();

    if(window.innerWidth < 1000) {
      return false;
    }
    if($(this).parent().find('>.menu').length === 0) {
      return false;
    }

    $(this).parent().toggleClass('active').siblings().removeClass('active');
      $('#primary-nav > .menu > li').hasClass('active') ? $fade.addClass('show') : $fade.removeClass('show');

  });
  // Mobile nav
  $('#header .hamburger').on('click', function () {
    if(window.innerWidth >= 1000) {
      return false;
    }
      $(this).toggleClass('is-active');
      $('#primary-nav').toggleClass('active');
      $('.fade').toggleClass('show');
  });

  subNavOpen('#primary-nav li span');
  subNavOpen('#primary-nav li a');
  subNavOpen('#primary-nav li');


  $fade.on('click', closeNav);
  $("#primary-nav .menu-item").on('click', closeNav);

  /**
   * Set a min-height to all slider item to have a unitary size(h);
   */
  function setHeroMinH() {
    var list = $('#heroCarousel').find('.carousel-item');
    var heights = [];

    $.each(list, function(ind, el) {
      heights.push($(el).outerHeight());
    });

    list.css('min-height', Math.max.apply(null, heights) + 'px');
  };

  //setHeroMinH();

  /**
   * Hero slider on homepage
   *
   * An argument can be provided as follows:
   *  {
   *   type: 'cookie' || 'session' || 'permanent',
   *   targetIdent: 'class' || 'id',
   *   targetChildrenIdent: 'class'
   *  }
   */

  function SliderSetter(opt) {
    this.settings = opt;
  };

  SliderSetter.prototype.writeCookie = function writeCookie(arg) {
    document.cookie = 'slideNo=' + arg;
  };

  SliderSetter.prototype.readCookie = function readCookie() {
    return parseInt(document.cookie.replace(/(?:(?:^|.*;\s*)slideNo\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
  };

  SliderSetter.prototype.readStorage = function readStorage() {
    if(sessionStorage.getItem('slideNo')) {
      return {
        type: 'session',
        value: parseInt(sessionStorage.getItem('slideNo'))
      }
    }

    return {
      type: 'permanent',
      value: parseInt(localStorage.getItem('slideNo'))
    };
  };

  SliderSetter.prototype.writeStorage = function writeStorage(type, arg) {
    if(type == 'session') {
      sessionStorage.setItem('slideNo', arg);
      return;
    }

    localStorage.setItem('slideNo', arg);
  };

  SliderSetter.prototype.getSlideNo = function getSlideNo(ident) {
    return $(ident).children().length;
  };

  SliderSetter.prototype.init = function init() {
    var slideLen = this.getSlideNo(this.settings.targetIdent);
    var cookieVal = this.readCookie();
    var storageVal = this.readStorage();

    if(cookieVal >= 0 && cookieVal < slideLen) {
      this.writeCookie(cookieVal + 1);
      this.sliderInit(parseInt(cookieVal));
      return;
    } else if(cookieVal >= 0 && cookieVal == slideLen) {
      this.writeCookie(1);
      this.sliderInit(0);
      return;
    } else if(cookieVal >= 0 && cookieVal > slideLen) {
      this.writeCookie(1);
      this.sliderInit(0);
      return;
    }

    if(storageVal.value >= 0 && storageVal.value < slideLen) {
      //console.log('here');
      this.writeStorage(storageVal.type, (parseInt(storageVal.value) + 1));
      this.sliderInit(parseInt(storageVal.value));
      return;
    } else if(storageVal.value >= 0 && storageVal.value == slideLen) {
      this.writeStorage(storageVal.type, 1);
      this.sliderInit(0);
      return;
    } else if(storageVal.value >= 0 && storageVal.value > slideLen) {
      this.writeStorage(storageVal.type, 1);
      this.sliderInit(0);
      return;
    }

    switch(this.settings.type) {
      case 'cookie':
        if(slideLen > 1) {
          this.writeCookie(1);
        } else {
          this.writeCookie(0);
        }
        this.sliderInit(0);
        break;
      case 'session':
        if(slideLen > 1) {
          this.writeStorage('session', 1);
        } else {
          this.writeStorage('session', 0);
        }
        this.sliderInit(0);
        break;
      default:
        if(slideLen > 1) {
          this.writeStorage('permanent', 1);
        } else {
          this.writeStorage('permanent', 0);
        }
        this.sliderInit(0);
    };
  };

  SliderSetter.prototype.sliderInit = function sliderInit(firstSlide) {
    var self = this;

    $(self.settings.targetIdent).slick({
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      infinite: false,
      initialSlide: firstSlide,
      zIndex: 1
    });

    setHeroMinH();
  };

  function mainHeroInit(opt) {
    var settings = {
      type: 'permanent',
      targetIdent: '#heroCarousel',
      targetChildrenIdent: '.carousel-item'
    };

    if(opt) {
      for(var prop in opt) {
        settings[prop] = opt[prop];
      }
    }

    var sliderSetter = new SliderSetter(settings);
    sliderSetter.init();

  };

  mainHeroInit();

  // Experts slider on newsroom page
  $('.newsroom-sidebar .experts .row').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    initialSlide: 0,
  });

  $('.hero-image-carousel-container').slick({
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    infinite: false,
    initialSlide: 0,
    zIndex: 1
  });

  // Contact us page

  $('.department-selected').on('click', function() {
    $(this).next().slideToggle('fast');
  });
  $('.select-list li').on('click', function () {
    var $content = $(this).text();
    $('.department-selected').text($content);
    $('.select-list').slideUp('fast');
    $('.contact-us-form').fadeIn();

  });

  // Mission Support page
  function missionSupport() {
    $('.contract-select-tab, .MST-tab').on('click', function() {

      if(window.innerWidth < 670) {
        $(this)
          .toggleClass('active')
          .children("." + $(this).attr('data-tab'))
          .toggleClass('active');

        return;
      }

      $(this)
        .addClass('active')
        .siblings()
        .removeClass('active');

      $("." + $(this).attr('data-tab'))
        .addClass('active')
        .siblings()
        .removeClass('active');
    });

    $('.contract-select-tab:first-child, .MST-tab:first-child').click();
  };

  function resetMissionSupport() {
    if(window.innerWidth >= 670) {
      $('.description-mob').removeClass('active');
      $('.contract-select-tab:first-child, .MST-tab:first-child').click();
    }
  };

  missionSupport();

  //  function flexFont() {
  //   var divs = $(".tile");
  //    $.each( divs, function(){
  //      var minSize = $(this).outerWidth() < $(this).outerHeight() ? $(this).outerWidth() : $(this).outerHeight();
  //      var relFontsize = minSize * 0.05;
  //      $(this).css('font-size', relFontsize+'px');
  //    });
  // }
  //
  // if (window.matchMedia('(max-width: 1200px)').matches) {
  //   window.onload = function(event) {
  //     flexFont();
  //   };
  // }
  //
  // window.onresize = function(event) {
  //   closeNav();
  //   flexFont();
  // };

  /**
   * Instagram block change padding based on position
   */

  function instaBlockPadding() {
    var instaContainer = $('#instagram-block').parent().children();
    var listOfIDs = [];
    var instaPos;

    $.each(instaContainer, function(ind, el) {
      listOfIDs.push($(el).attr('id'))
    });

    instaPos = listOfIDs.indexOf('instagram-block');

    if(instaPos == 0) {
      $('.insta-block-title').css('padding-top', '15px')
    }
  }

  instaBlockPadding();

  /**
   * Debounce function implementation
   */

  function _debounce(fn, delay) {
    var timeout;

    if(!fn.length) {
      throw 'Set at least one fn in the array argument for the _debounce function!'; // Throw an error if no arguments are passed to the _debaounce function.
    }

    return function() {
      if(timeout) clearTimeout(timeout);

      timeout = setTimeout(function() {
            fn.forEach(function (el) {
              el();
            });
          }, // If the callback function DOES NOT have an argument, it is called here.
        (delay ? delay : 50) // If no delay is set for the setTimeout, it default to 50.
      );
    }
  };

  /**
   Center menu above 1200px
   */

  function setPadding() {
    if (window.innerWidth > 1000) {
      $('.fade').removeClass('show');
      //$('.main--menu').removeClass('main--menu-animation');
      $('#primary-nav').removeClass('main--menu-animation');
    } else if (window.innerWidth < 1000 && $('#primary-nav').hasClass('active')) {
      $('.fade').addClass('show');
    }

    if (window.innerWidth < 1000) {
      $('#primary-nav').addClass('main--menu-animation');
    }

    if(window.innerWidth > 1200) {

      var paddingValue = (window.innerWidth - 1160)/2;
      $('#primary-nav .menu-item.menu-item--expanded > .menu').css({
        'padding-left': paddingValue + 'px',
        'padding-right': paddingValue + 'px'
      });
      return;
    }

    $('#primary-nav .menu-item.menu-item--expanded > .menu').css({
      'padding-left': '20px',
      'padding-right':'20px'
    })
  };

  $(window).on('load resize', _debounce([setPadding, resetMissionSupport, setHeroMinH]));

  // topics list behaviour

  $('#topics li.active a').unbind().on('click', function(ev) {
    ev.preventDefault();
    $(this).parent().siblings().toggleClass('open');
  });

  /**
   * Sticky side container
   */

  $(window).on('load', function() {
    var markersList = $('[class^="sticky-marker-"]');
    var containerSizes = [];
    var sideID = '#sticky-';
    var markerClass = '.sticky-marker-';

    // Exit function if there are no elements with the `markerClass`.
    if(!markersList) {
      return;
    }

    // Create a list of container sizes based on the `markerClass` elements.
    // For each `markerClass` element, measure the distance between the top
    // of the current element and the top of the next element. If there is no
    // next exists, get the bottom of the containing/parent element.
    $.each(markersList, function(ind, el) {
      var OS = ($(el).offset()).top;
      var OSN = $(markersList[ind + 1]).length ? ($(markersList[ind + 1]).offset()).top : '';
      var regex = /[0-9]/g;
      var clsNo = $(el)[0].className.match(regex).join('');

      if(!OSN) {
        OSN = ($(el).parent().offset()).top + $(el).parent().outerHeight();
      }

      containerSizes.push({
        key: clsNo,
        value: Math.abs(OS - OSN)
      });

    });

    // For each side floating element, create a wrapper element
    // and set its height based on the previously created list.
    //
    // During the first iteration, set a padding on the containing element
    // to offset top the first floating element to the position of the first
    // marker element.
    //
    // Finally, initialize the `stickr` library for each element.
    $.each(containerSizes, function(ind, el) {
      if(!ind) {
        var parentPad = ($(markerClass + el.key).offset()).top - ($(markerClass + el.key).parent().offset()).top;

        $(sideID + el.key).parent().css('padding-top', parentPad + "px");
      }

      $(sideID + el.key)
        .wrap("<div class='sticky-container-side-" + el.key + "'></div>")
        .parent()
        .css({'height': el.value + "px"});

      $(sideID + el.key).stickr({
        duration: 0,
        offsetTop: 100,
        offsetBottom: 38
      });

    });

  })

})(jQuery);